import React from 'react'
import {
  ShowView,
  ShowController,
  TabbedShowLayout,
  TextField,
  Tab,
  FunctionField,
} from 'react-admin'
import { ParticipantsList } from './ParticipantsList'
import { RequestsList } from './RequestsList'
import { TournamentsList } from './TournamentsList'
import { StatisticList } from './StatisticList'
import { formatSportKind } from '../utils/format'

const TournamentTitle = ({ record }) => {
  return <span>{record.name ? record.name : ''}</span>
}

const ShowClub = (props) => {
  return (
    <ShowController {...props}>
      {(controllerProps) => (
        <ShowView {...props} {...controllerProps} title={<TournamentTitle />}>
          <TabbedShowLayout>
            <Tab label='Информация'>
              <TextField source='name' label='Название' />
              <TextField source='city.name' label='Город' />
              <FunctionField
                label='Вид спорта'
                render={(record) => formatSportKind(record.sportKind)}
              />
              <TextField
                source='address'
                label='Адрес'
                emptyText='Не указано'
              />
              <TextField source='email' label='E-mail' emptyText='Не указано' />
              <TextField
                source='phone'
                label='Контактный телефон'
                emptyText='Не указано'
              />
              <TextField source='site' label='Сайт' emptyText='Не указано' />
              <TextField
                source='totalMembers'
                label='Кол-во участников'
                emptyText='Не указано'
              />
            </Tab>

            <Tab label='Статистика'>
              <TextField source='gold' label='Золото' />
              <TextField source='silver' label='Серебро' />
              <TextField source='bronze' label='Бронза' />
              <StatisticList {...props} />
            </Tab>
            {controllerProps?.record?.isModerated && (
              <Tab label='Заявки'>
                <RequestsList />
              </Tab>
            )}
            <Tab label='Участники'>
              <ParticipantsList />
            </Tab>
            <Tab label='Регистрации'>
              <TournamentsList />
            </Tab>
          </TabbedShowLayout>
        </ShowView>
      )}
    </ShowController>
  )
}

export default ShowClub
